"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require("./../../Button");

var _Button2 = _interopRequireDefault(_Button);

var _DropdownButton = require("react-bootstrap/lib/DropdownButton");

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _InputGroupAddon = require("react-bootstrap/lib/InputGroupAddon");

var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);

var _InputGroupButton = require("react-bootstrap/lib/InputGroupButton");

var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputAddon = function (_React$Component) {
  _inherits(InputAddon, _React$Component);

  function InputAddon() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputAddon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputAddon.__proto__ || Object.getPrototypeOf(InputAddon)).call.apply(_ref, [this].concat(args))), _this), _this.getAddon = function () {
      var _this$props = _this.props,
          addonType = _this$props.addonType,
          children = _this$props.children,
          className = _this$props.className,
          disabled = _this$props.disabled,
          htmlId = _this$props.htmlId,
          hasIcon = _this$props.hasIcon,
          validationState = _this$props.validationState,
          props = _objectWithoutProperties(_this$props, ["addonType", "children", "className", "disabled", "htmlId", "hasIcon", "validationState"]);

      var validationClass = validationState === "error" ? "danger" : validationState || "";
      var iconClass = hasIcon ? "addon-icon " : "";

      var addonClasses = "addon-wrapper " + iconClass + validationClass;

      if (addonType === "button") {
        return _react2.default.createElement(
          _InputGroupButton2.default,
          { className: addonClasses, disabled: disabled },
          _react2.default.createElement(
            _Button2.default,
            Object.assign({ disabled: disabled, className: className, htmlId: htmlId }, props),
            children
          )
        );
      } else if (addonType === "dropdownButton") {
        return _react2.default.createElement(
          _InputGroupButton2.default,
          {
            className: "input-group-dropdown-btn " + addonClasses,
            disabled: disabled
          },
          _react2.default.createElement(
            _DropdownButton2.default,
            Object.assign({ id: htmlId }, Object.assign({ disabled: disabled, className: className }, props)),
            children
          )
        );
      } else if (addonType === "addon") {
        return _react2.default.createElement(
          _InputGroupAddon2.default,
          {
            className: addonClasses + " " + (className ? className : ""),
            disabled: disabled
          },
          _react2.default.createElement(
            "div",
            { className: (hasIcon ? "addon-svg-wrapper" : "") + " " },
            children
          )
        );
      }
      return children;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputAddon, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.getAddon()
      );
    }
  }]);

  return InputAddon;
}(_react2.default.Component);

InputAddon.propTypes = {
  addonType: _propTypes2.default.oneOf(["addon", "button", "dropdownButton"]),
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object, _propTypes2.default.string]),
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool.isRequired,
  hasIcon: _propTypes2.default.bool.isRequired,
  validationState: _propTypes2.default.string
};

InputAddon.defaultProps = {
  addonType: "addon",
  disabled: false,
  hasIcon: false
};

exports.default = InputAddon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/internal/InputAddon/InputAddon.js
// module id = 557
// module chunks = 0